import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { Button } from "react-bootstrap";
import BackButton from "../../Common/BackButton/BackButton";
import Loader from "../../Common/Loader/loader";

const baseUrl = process.env.REACT_APP_API_PATH;

const ScheduledInterviewMoreInfo = () => {
  const { userResult } = useSelector((state) => state.Auth);
  const { interviewId } = useParams();
  const interviewIDFromURL = interviewId;
  const userIdData = userResult?.userid;;
  const [loading, setLoading] = useState(false);

  const userInfo = useSelector((state) => state.Profile.result);
  const vendorIdData = userInfo?.vendorId;

  const location = useLocation();
  let receivedDataVar;
  const [receivedData, setreceivedDataState] = useState(null);

  const [reload, setReload] = useState(false);

  const setReloadFunction = () => {
    setTimeout(() => {
      setReload(!reload);
    }, 1000);
  };

  useEffect(() => {
    try {
      setLoading(true);
      const fetchDataFunction = async () => {
        const dataToSet = await axios.get(
          `${baseUrl}/ebench/interview/get_interview_by_interviewId?interviewId=${interviewIDFromURL}`
        );
        receivedDataVar = await dataToSet.data.data;
        setreceivedDataState(receivedDataVar);
        setLoading(false);
      };
      console.log(reload);

      fetchDataFunction();
    } catch (error) {
      console.error("Error at AssignedInterviewsInfo:", error);
    }
  }, [reload]);
  //  console.log(receivedData,"DAAAAAAATTTTTTTAAAAAAAAAAA")
  console.log("DAAAAAAATTTTTTTAAAAAAAAAAA", receivedData?.timeZone);


  if (loading) {
    return (
      <div style={{ height: "70vh", display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Loader />
      </div>
    )
  }
  return (
    <>
      <div className="vj_wrapper container">
        <BackButton />
        <div className="vj_container d-flex justify-content-between ">
          <div
            // className="vj_left "
            style={{
              minWidth: "90%",
              padding: "10px",
              boxShadow: "1px 1px 10px rgba(0, 0, 0, 0.1)",
            }}
          >
            <div className="common_table_header">
              <p
                style={{
                  margin: "0px",
                  paddingTop: "0px",
                }}
              >
                {receivedData?.interviewTitle || "N/A"}
              </p>
            </div>
            <div className="line_divide"></div>

            <div className="vj_jobInfo mt-3 d-flex flex-column flex-md-row gap-3">
              <div
                className="vj_info_main"
                style={{ maxWidth: "40%", marginLeft: "20px", minWidth: "40%" }}
              >
                {receivedData?.jobUuid && (
                  <p className="">
                    Job ID:{" "}
                    <span className="text-secondary fw-normal">
                      {receivedData?.jobUuid}
                    </span>{" "}
                  </p>
                )}
                <p className="">
                  Candidate Name:{" "}
                  <span className="text-secondary fw-normal">
                    {receivedData?.candidateName}
                  </span>{" "}
                </p>

                <p className="">
                  Candidate EmpId :{" "}
                  <span className="text-secondary fw-normal">
                    {receivedData?.candidateEmpId || "N/A"}
                  </span>{" "}
                </p>
                <p className="">
                  Duration:{" "}
                  <span className="text-secondary fw-normal">
                    {receivedData?.duration || "N/A"}
                  </span>{" "}
                </p>
                <p className="">
                  Interview Date:{" "}
                  <span className="text-secondary fw-normal">
                    {receivedData?.interviewDate.split(" ")[0].split("-")[2] +
                      "-" +
                      receivedData?.interviewDate.split(" ")[0].split("-")[1] +
                      "-" +
                      receivedData?.interviewDate.split(" ")[0].split("-")[0] ||
                      "N/A"}
                  </span>{" "}
                </p>
                <p className="">
                  Interview Time:{" "}
                  <span className="text-secondary fw-normal">
                    {receivedData?.interviewDate.split(" ")[1] || "N/A"}
                    {receivedData?.timeZone
                      ? receivedData?.timeZone.split(" ")[0]
                      : ""}
                  </span>{" "}
                </p>

                {receivedData?.candidateInterviewStatus !== null && (
                  <p className="">
                    Interview Status:{" "}
                    <span className="text-secondary fw-normal">
                      {receivedData?.candidateInterviewStatus === "SELECT"
                        ? "Selected"
                        : receivedData?.candidateInterviewStatus === "REJECT"
                        ? "Rejected"
                        : receivedData?.candidateInterviewStatus === "ONHOLD"
                        ? "On Hold"
                        : receivedData?.candidateInterviewStatus === "PENDING"
                        ? "Pending"
                        : receivedData?.candidateInterviewStatus ===
                          "NEXT_ROUND"
                        ? "Next Round"
                                : receivedData?.candidateInterviewStatus}
                    </span>{" "}
                  </p>
                )}
                {receivedData?.rating !== null && (
                  <p className="">
                    Score:{" "}
                    <span className="text-secondary fw-normal">
                      {receivedData?.rating || "N/A"}
                    </span>{" "}
                  </p>
                )}
              </div>
              {/* ------------------------ */}
              <div className="vj_info_main">
                {/* <p className="">
                  Interview Status:{" "}
                  <span
                    className={` ${
                      receivedData?.interviewStatus === "COMPLETED"
                        ? "textGreenForStatus"
                        : receivedData?.interviewStatus === "CANCELLED"
                        ? "textRedForStatus"
                        : "text-secondary fw-normal"
                    } `}
                  >
                    {receivedData?.interviewStatus}
                  </span>{" "}
                </p> */}
                <p className="">
                  Interview Type:{" "}
                  <span className="text-secondary fw-normal">
                    {receivedData?.inteviewType === "HR"
                      ? receivedData?.inteviewType
                      : receivedData?.inteviewType.charAt(0).toUpperCase() +
                        receivedData?.inteviewType.slice(1).toLowerCase()}
                  </span>{" "}
                </p>
                <p className="">
                  Interviewer Name:{" "}
                  <span className="text-secondary fw-normal">
                    {receivedData?.interviewerName}
                  </span>{" "}
                </p>
                <p className="">
                  Interviewer ID:{" "}
                  <span className="text-secondary fw-normal">
                    {receivedData?.interviewerEmpId}
                  </span>{" "}
                </p>
                {receivedData?.interviewStatus == "SCHEDULED" &&
                  receivedData?.interviewLink && (
                    <p className="">
                      Interview Link:{" "}
                      <span>
                        <a
                          className="linkStyling2"
                          href={receivedData?.interviewLink}
                          target="_blank"
                        >
                          {receivedData?.interviewLink}
                        </a>
                      </span>{" "}
                    </p>
                  )}
                {receivedData?.resumeFileUrl && (
                  <p className="">
                    Resume:{" "}
                    <a
                      target="_blank"
                      href={receivedData?.resumeFileUrl}
                      className="linkStyling2"
                    >
                      Click Here
                    </a>{" "}
                  </p>
                )}
                {receivedData?.remark !== null && (
                  <p className="">
                    Feedback:{" "}
                    <span className="text-secondary fw-normal">
                      {receivedData?.remark}
                    </span>{" "}
                  </p>
                )}
                {receivedData?.jobAttachmentFile && (
                  <p className="">
                    {/* Assignment:{" "} */}
                    <a href={receivedData?.jobAttachmentFile} target="_blank">
                      <button
                        type="button"
                        style={{ width: "170px" }}
                        class="btn btn-outline-success"
                      >
                        View Assignment
                      </button>
                    </a>
                  </p>
                )}
              </div>
            </div>
            {/* ------------------------------------------------------------------ */}
            <div className="vj_apply mt-2"></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ScheduledInterviewMoreInfo;
